var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHackettip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4114_5011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47714 0 0 4.47714 0 10C0 15.5229 4.47714 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47714 15.5229 0 10 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84119 12.8869V15.9971C6.84119 17.6553 8.18591 19 9.84413 19C11.5023 19 12.8471 17.6553 12.8471 15.9971V12.9116C14.86 11.7566 16.1305 9.63643 16.18 7.30997C16.1635 5.57751 15.4458 3.91929 14.1835 2.72306C11.6343 0.322357 7.62492 0.446105 5.22422 2.99531C4.12699 4.15853 3.5165 5.693 3.5 7.28522C3.5495 9.61168 4.81172 11.7401 6.84119 12.8869ZM11.7581 15.1226H7.93841V14.3058H11.7581V15.1226ZM9.84413 17.8533C8.92015 17.812 8.15291 17.1273 8.01266 16.2116H11.6756C11.5353 17.1273 10.7681 17.812 9.84413 17.8533ZM9.51413 2.12082H9.84413C11.1724 2.12907 12.4511 2.63231 13.4246 3.5398C15.5118 5.54451 15.5778 8.86919 13.5731 10.9564C13.1276 11.4184 12.6078 11.7896 12.0303 12.0619C11.8571 12.1609 11.7498 12.3506 11.7581 12.5569V13.2086H7.93841V12.5569C7.94666 12.3506 7.84767 12.1444 7.66617 12.0371C5.79346 11.2204 4.58898 9.35594 4.60548 7.30997C4.66323 4.57928 6.79169 2.33532 9.51413 2.12082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2539 6.00586V7.2373L12.4287 6.99121L12.4297 6.99023L13.2031 6.01953L13.2139 6.00586H13.9746L13.9297 6.0625L12.9482 7.30664L13.9395 8.87793L13.9736 8.93164H13.2031L13.1934 8.91504L12.4648 7.74316L12.2539 7.89453V8.93164H11.5781V6.00586H12.2539Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2754 5.96484C10.5585 5.96484 10.842 6.0339 11.126 6.16992L11.1562 6.18359L11.1436 6.21387L10.9482 6.70605L10.9346 6.74121L10.9014 6.72461C10.7957 6.67435 10.6889 6.63108 10.582 6.59375C10.4773 6.55718 10.3752 6.53906 10.2754 6.53906C10.0578 6.53906 9.89229 6.62018 9.77441 6.78223C9.65539 6.94465 9.59375 7.17482 9.59375 7.47656C9.59375 7.7915 9.65274 8.02142 9.76562 8.17188C9.87712 8.32043 10.045 8.39648 10.2754 8.39648C10.4705 8.39648 10.7091 8.34758 10.9922 8.24805L11.0391 8.23145V8.8125L11.0176 8.82129C10.7784 8.92095 10.5118 8.9707 10.2188 8.9707C9.84856 8.9707 9.55071 8.8723 9.3291 8.67285L9.23926 8.58203C9.01176 8.32088 8.90039 7.94905 8.90039 7.47266C8.90039 7.17153 8.95561 6.90601 9.06641 6.67773C9.17729 6.44815 9.33687 6.27156 9.54492 6.14941C9.75417 6.02606 9.99807 5.96484 10.2754 5.96484Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64062 6.00586V7.125H7.70117V6.00586H8.375V8.93164H7.70117V7.69922H6.64062V8.93164H5.96484V6.00586H6.64062Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.07
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4114_5011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHackettip);
export default __webpack_public_path__ + "static/media/hackettip.73b217507a84db9f9aeb93e62afc35b7.svg";
export { ForwardRef as ReactComponent };